import React from 'react';
import ReceiptListFunctional from './components/receipt-list-functional';

const ReceiptList = () => {
	return <ReceiptListFunctional />;
};

export default ReceiptList;
